/** @format */

import React from "react";

export default ({ fillColor = "#191919" }) => (
  <svg width="15" height="15" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12.5" cy="12.5" r="11.75" stroke="#191919" stroke-width="1.5"/>
  <path d="M4 20.85C4 20.85 4.94223 16.9913 7.16125 15.5572C10.3736 13.4809 14.4864 13.4809 17.6988 15.5572C19.9178 16.9913 20.86 20.85 20.86 20.85" stroke="#191919" stroke-width="1.5"/>
  <circle cx="12.75" cy="7.75" r="4" stroke="#191919" stroke-width="1.5"/>
  </svg>
);
